module.exports = __webpack_public_path__ + "static/alrightLogo-red-e5459e4b26a7705cf04f42f951feb477.svg";